import React, { useState, useEffect } from 'react';
import '../../../styles/dashboardPagesStyle/Charts.css';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
  LabelList
} from 'recharts';
import { Info } from 'lucide-react';
import { getEvolucaoDeVendas, EvolucaoDeVendasResponse } from "../../../API/dashboardPageService";

interface VendasDataItem {
  mes: string;
  Atual: number;
  Media: number;
}

export default function EvolucaoVendasChart() {
  const [dataVendas, setDataVendas] = useState<VendasDataItem[]>([]);
  const [popup, setPopup] = useState<{ visible: boolean; text: string }>({
    visible: false,
    text: '',
  });

  useEffect(() => {
    async function fetchData() {
      try {
        const response: EvolucaoDeVendasResponse = await getEvolucaoDeVendas();
        const historicoUltimos6 = response.historico_vendas.slice(-6);

        const formatted = historicoUltimos6.map(item => ({
          mes: item.mes,
          Atual: item.vendidas,
          Media: response.media_vendas,
        }));

        setDataVendas(formatted);
      } catch (error) {
        console.error("Erro ao carregar evolução de vendas", error);
      }
    }

    fetchData();
  }, []);

  const handleInfoClick = () => {
    setPopup({
      visible: true,
      text: 'Este gráfico mostra a evolução das vendas mês a mês, comparando o valor atual com a média histórica.',
    });
  };

  const fecharPopup = () => setPopup({ visible: false, text: '' });

  const renderPercentLabel = (props: any) => {
    const { x, y, value, index } = props;
    const media = dataVendas[index]?.Media || 0;
    const diff = media > 0 ? ((value - media) / media) * 100 : 0;
    const arrow = diff >= 0 ? '↑' : '↓';
    const color = diff >= 0 ? '#29306A' : '#f80202ff';

    const labelText = `${arrow} ${Math.abs(diff).toFixed(1)}%`;
    const padding = 6;
    const fontSize = 10;
    const textWidth = labelText.length * (fontSize * 0.6);
    const textHeight = fontSize + padding;

    // Centraliza horizontalmente e sobe verticalmente
    const xPos = x - textWidth / 2;
    const yPos = y - textHeight - 10; // sobe acima da linha

    return (
      <g transform={`translate(${xPos}, ${yPos})`} style={{ pointerEvents: 'none' }}>
        <rect
          width={textWidth + padding}
          height={textHeight}
          fill="#f0efefff"
          rx={6}
          ry={6}
          filter="drop-shadow(0 1px 1px rgba(185, 6, 6, 0.1))"
        />
        <text
          x={(textWidth + padding) / 2}
          y={textHeight / 2}
          fill={color}
          fontWeight="bold"
          fontSize={fontSize}
          dominantBaseline="middle"
          textAnchor="middle"
        >
          {labelText}
        </text>
      </g>
    );
  };


  return (
    <div className="card-grafico-evolucao info-card">
      <h3>Evolução de vendas</h3>
      <Info className="info-btn" size={20} onClick={handleInfoClick} />

      <ResponsiveContainer width="100%" height={200} style={{ overflow: 'visible' }} >
        <LineChart 
          data={dataVendas} 
          margin={{ top: 40, right: 30, bottom: 5, left: -20 }} // deixa mais à esquerda
        >
          <XAxis dataKey="mes" style={{ fontSize: '12px' }}/>
          <YAxis style={{ fontSize: '12px' }}/>
          <Tooltip />
          <Legend />
          
          <Line
            type="monotone"
            dataKey="Media"
            stroke="#32BEF0"
            strokeWidth={2}
            strokeDasharray="3 1"
            isAnimationActive={false}
          />

          <Line
            type="monotone"
            dataKey="Atual"
            stroke="#29306A"
            strokeWidth={2}
            isAnimationActive={false}
            label={renderPercentLabel}
          >
            <LabelList content={renderPercentLabel} />
          </Line>
        </LineChart>
      </ResponsiveContainer>

      {popup.visible && (
        <div className="info-popup-overlay" onClick={fecharPopup}>
          <div className="info-popup" onClick={e => e.stopPropagation()}>
            <h4>Informações</h4>
            <p>{popup.text}</p>
            <button onClick={fecharPopup}>Fechar</button>
          </div>
        </div>
      )}
    </div>
  );
}
